import { motion } from "framer-motion";
import { useLanguage } from "@/context/LanguageContext";

export default function PhoneMockup() {
  const { logo, t } = useLanguage();

  return (
    <div className="relative mx-auto w-[260px] sm:w-[300px]" data-testid="phone-mockup">
      <div className="absolute -inset-10 rounded-full bg-[#DAE13B]/30 blur-3xl pointer-events-none" />
      <motion.div
        initial={{ opacity: 0, y: 40, rotateX: 8 }}
        whileInView={{ opacity: 1, y: 0, rotateX: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1] }}
        className="relative rounded-[3rem] bg-[#1c1c1c] p-[10px] shadow-[0_40px_90px_-30px_rgba(15,23,42,0.55)]"
      >
        <span className="absolute top-[86px] -start-[3px] w-[3px] h-8 rounded-s bg-[#2b2b2b]" />
        <span className="absolute top-[130px] -start-[3px] w-[3px] h-14 rounded-s bg-[#2b2b2b]" />
        <span className="absolute top-[110px] -end-[3px] w-[3px] h-20 rounded-e bg-[#2b2b2b]" />
        <div className="relative aspect-[9/19.5] rounded-[2.4rem] overflow-hidden bg-gradient-to-b from-white via-[#f7fbe9] to-[#eef7d2] flex flex-col items-center justify-center">
          <span className="absolute top-3 w-24 h-6 rounded-full bg-[#1c1c1c]" />
          <motion.img
            src={logo}
            alt="Tafakar app"
            data-testid="phone-logo"
            initial={{ scale: 0.6, opacity: 0 }}
            whileInView={{ scale: 1, opacity: 1 }}
            viewport={{ once: true }}
            transition={{ delay: 0.5, duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
            className="w-[58%] drop-shadow-[0_14px_30px_rgba(171,207,57,0.35)]"
          />
          <motion.p
            initial={{ opacity: 0, y: 10 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: 0.9, duration: 0.6 }}
            className="mt-5 font-display font-bold text-base sm:text-lg text-[#383838] text-center"
            data-testid="phone-tagline"
          >
            {t.phone.tagline}
          </motion.p>
          <div className="absolute bottom-16 flex items-center gap-1.5">
            {[0, 1, 2].map((i) => (
              <motion.span
                key={i}
                animate={{ opacity: [0.25, 1, 0.25], scale: [0.85, 1, 0.85] }}
                transition={{ duration: 1.2, repeat: Infinity, delay: i * 0.2 }}
                className="w-2 h-2 rounded-full bg-[#ABCF39]"
              />
            ))}
          </div>
          <span className="absolute bottom-3 w-28 h-1 rounded-full bg-[#383838]/60" />
        </div>
      </motion.div>
    </div>
  );
}
